import HabitPackCard from 'components/setting-generator-revamp/tabs-body-steps-revamp/habit-packs/pack-lists/HabitPackCard';
import EmptyState from 'components/ui/EmptyState';
import { HABIT_PACK_OPTION } from 'constants/general';
import { ATTRIB } from 'constants/test';
import { HabitPackType } from 'interfaces/common.interface';
import { t } from 'services/i18n.service';
import { isRouteEmbedded } from 'utils/routes.util';

interface HabitPackItemsProps {
  habitPacks: HabitPackType[];
  packType: string;
}

const HabitPackItems = ({ habitPacks, packType }: HabitPackItemsProps) => {
  return habitPacks.length ? (
    <div
      className={`w-full h-fit ${isRouteEmbedded ? 'max-h-full' : ''} flex flex-col items-center ~p-1/2 ~gap-4/6 overflow-y-auto scroll-pl-4 scrollbar-thin scrollbar-thumb-primary-500 dark:scrollbar-thumb-primary-dark-400`}
      data-testid={ATTRIB.DATA_TESTID.HABIT_PACK_LIST_SECTION}>
      {habitPacks.map((pack) => (
        <HabitPackCard key={pack.id} habitPack={pack} />
      ))}
    </div>
  ) : (
    <EmptyState
      title=''
      description={
        packType === HABIT_PACK_OPTION.INSTALLED
          ? t('packs.no_packs_installed_message')
          : t('packs.no_featured_packs_message')
      }
    />
  );
};
export default HabitPackItems;
